/**
 * Determines if the current vehicle is in the list of vehicles whose insert locations should be restricted.
 *
 * @param {Array} vehicleTitle - The vehicle title array from the vehicle data.
 * @param {string} restrictInsertLocationsForVehicles - The value of the restrictInsertLocationsForVehicles preference.
 */
export const getTargetLocations = (
	vehicleTitle,
	restrictInsertLocationsForVehicles
) => {
	const targetLocations = new Set();

	if (!restrictInsertLocationsForVehicles) {
		return targetLocations;
	}

	const vehicleTitleStr = vehicleTitle
		.map(title => title.toString().trim())
		.join(' ');

	if (restrictInsertLocationsForVehicles) {
		restrictInsertLocationsForVehicles.split('|').forEach(configEntry => {
			if (configEntry.includes(':')) {
				const locationEntry = configEntry.split(':');
				const vehicleTitleToMatch = locationEntry[0];
				if (vehicleTitleStr.match(vehicleTitleToMatch)) {
					locationEntry[1]
						.trim()
						.split(',')
						.forEach(location => {
							targetLocations.add(location);
						});
				}
			}
		});
	}

	return targetLocations;
};
